import { render, staticRenderFns } from "./couponList.vue?vue&type=template&id=69471500&scoped=true&"
import script from "./couponList.vue?vue&type=script&lang=js&"
export * from "./couponList.vue?vue&type=script&lang=js&"
import style0 from "./couponList.vue?vue&type=style&index=0&id=69471500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69471500",
  null
  
)

export default component.exports